import cookie from 'js-cookie'
import {COMMON_ROUTER} from "../constants";

// 获取当前用户cookie
export const getToken = () => {
  return cookie.get('usertoken')
}

// 用户登录，保存cookie
export const setToken = (user) => {
  cookie.set('usertoken', user, {expires: 1, path: '/'})
}

// 用户登出，删除cookie
export const removeToken = () => {
  cookie.remove('usertoken')
  // window.location.href = '/Login'
  window.location.href = COMMON_ROUTER + '/'
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js